import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee301b68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "latest-news-wrap" }
const _hoisted_2 = { class: "latest-news" }
const _hoisted_3 = {
  key: 0,
  class: "latest-news-title"
}
const _hoisted_4 = { class: "latest-news-body-wrap" }
const _hoisted_5 = { class: "latest-news-body-block" }
const _hoisted_6 = { class: "latest-news-body" }
const _hoisted_7 = { class: "latest-news-body" }
const _hoisted_8 = { class: "latest-news-body" }
const _hoisted_9 = { class: "latest-news-body small" }
const _hoisted_10 = {
  key: 1,
  class: "latest-news-button-wrap"
}

import {BlockSmallCard, WrapTitle} from "@/entities";
import {UiButton, useDataStore, useLocalizationStore} from "@/shared";
import {useRouter} from "vue-router";
import {computed} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'latest-news',
  props: {
  showButton: {
    type: Boolean,
    default: true,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
  others: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const {getArrLatestNow} = useDataStore();
const {translate} = useLocalizationStore();
const router = useRouter();


const onClick = () => {
  router.push({name: "news"});
};

const getLatestNow = computed(() => {
  return getArrLatestNow(props.others);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.showTitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(WrapTitle), {
              text: _unref(translate)('later_news_span'),
              class: "preview-data-header-title",
              size: "regular",
              weight: "700"
            }, null, 8, ["text"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getLatestNow.value, (item, ind) => {
              return _withDirectives((_openBlock(), _createBlock(_unref(BlockSmallCard), {
                key: ind,
                height: ind<3?'250px':'200px',
                width: ind<3?'408px':'301px',
                image: item.Image,
                link: item.Link,
                text: _unref(translate)(item.Text)
              }, null, 8, ["height", "width", "image", "link", "text"])), [
                [_vShow, ind<3]
              ])
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getLatestNow.value, (item, ind) => {
              return _withDirectives((_openBlock(), _createBlock(_unref(BlockSmallCard), {
                key: ind,
                height: ind<3?'250px':'200px',
                width: ind<3?'408px':'301px',
                image: item.Image,
                link: item.Link,
                text: _unref(translate)(item.Text)
              }, null, 8, ["height", "width", "image", "link", "text"])), [
                [_vShow, ind>2 && ind < 7]
              ])
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getLatestNow.value, (item, ind) => {
              return _withDirectives((_openBlock(), _createBlock(_unref(BlockSmallCard), {
                key: ind,
                height: ind>6?'250px':'200px',
                width: ind>6?'408px':'301px',
                image: item.Image,
                link: item.Link,
                text: _unref(translate)(item.Text)
              }, null, 8, ["height", "width", "image", "link", "text"])), [
                [_vShow, ind>6]
              ])
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getLatestNow.value, (item, ind) => {
            return (_openBlock(), _createBlock(_unref(BlockSmallCard), {
              key: ind,
              width: 'auto',
              image: item.Image,
              link: item.Link,
              text: _unref(translate)(item.Text),
              "image-on-phone": true
            }, null, 8, ["image", "link", "text"]))
          }), 128))
        ])
      ]),
      (__props.showButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_unref(UiButton), {
              class: "latest-news-button",
              color: "#71B92F",
              height: "45",
              onClick: onClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("all_news")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})